// @flow

export const APP_INITIAL: string = 'APP_INITIAL';
export const APP_LOADING: string = 'APP_LOADING';
export const APP_MODAL_ACTIVATOR: string = 'APP_MODAL_ACTIVATOR';
export const APP_ERROR: string = 'APP_ERROR';
export const APP_UPDATE_STATE: string = 'APP_UPDATE_STATE';



// WEBPACK FOOTER //
// ./src/constants/App.js